<div class="bar-chart-container ion-text-center">
  <canvas baseChart #baseBarChart [datasets]="chartDatas" [labels]="chartLabels" [options]="chartOptions" [legend]="isShowLegend" [chartType]="chartType" [plugins]="chartPlugins"></canvas>
</div>
